<template>
  <section class="app-main">
    <user-watermark />
    <router-view />
  </section>
</template>

<script>
import UserWatermark from '@/components/UserWatermark'

export default {
  components: {
    UserWatermark
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  position: relative;
  min-height: 100%;
  padding: 0;
}
</style>
